`<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-6 col-lg-10">
      <h2>{{ $t("navigations.site overview") }}</h2>
    </div>

  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0">Site Code</label>
            <select class="form-control" v-model="searchField.siteCode">
              <option value="">Select</option>
              <option v-for="site in sites" :key="site.siteID" :value="site.siteCode">
                {{ site.siteCode }}
              </option>
            </select>
          </div>
          <div class="form-group mb-lg-0 w-100 px-1">
            <label class="mb-0">Status</label>
            <input type="text" class="form-control my-md-2 my-lg-0" v-model="searchField.status" />
          </div>
          <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
            Search
          </span>
        </div>
      </div>
    </div>
    <div class="ibox-body">

      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.site list") }}</h5>
        <!-- <div
          
            class="position-relative cursor-pointer"
            @click.prevent="showFilter = !showFilter"
          >
            <img
              src="../../assets/img/filter.png"
              width="17"
              height="17"
              alt="filter table"
            />
            <div class="tool-tip">{{ $t("navigations.filter") }}</div>
          </div> -->
      </div>
      <div class="ibox-content">
        <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
          <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
            <div class="table-multi-select-dropdown" @click.stop="dropdownOpen = !dropdownOpen">
              <div class="selected-options">
                <span>Select Columns</span>
              </div>
              <div class="dropdown-arrow"></div>
            </div>
            <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
              <label v-for="(column, index) in getColumns" :key="index">
                <input type="checkbox" v-model="selectedcolumnobj[column]" :value="true" />
                {{ column }}
              </label>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="showOverdueLoading === true">
          <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
        <template v-else>
          <div class="text-center empty-state" v-if="overdueVisitList.length === 0">
            <div class="empty-icon">
              <i class="fa fa-inbox"></i>
            </div>
            <h5>{{ $t('navigations.no data available') }}</h5>
            <p class="text-muted">{{ $t('navigations.no kpi records found') }}</p>
          </div>
          <div v-else class="table-responsive strechtable minwidthdiv">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th class="text-center">
                    {{ $t("navigations.site code") }}
                  </th>
                  <th class="text-center">
                    {{ $t("navigations.Aggregate Risk Score") }}
                  </th>
                  <th class="text-center">
                    {{ $t("navigations.status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("navigations.risks") }}
                  </th>
                  <!-- <th
                      v-if="selectedcolumnobj['Date']"
                      class="sort_block"
                      @click="SortSelected('visitDate', 4)"
                      id="4"
                    >
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.date") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th> -->
                  <!-- <th class="text-center">{{ $t("navigations.forms") }}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="list in overdueVisitList" :key="list.sitcode">
                  <td class="text-center">
                    {{ list.siteCode }}
                  </td>
                  <td class="text-center">
                    {{ list.siteScore }}
                  </td>
                  <td class="text-center">
                    {{ list.status }}
                  </td>
                  <td class="text-center">
                    <i v-if="list.risks && list.risks.length > 0" class="fa fa-eye edit-delete cursor-pointer"
                      title="View Risks" @click.prevent="openRisksModal(list)"></i>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <!-- <td v-if="selectedcolumnobj['Date']">
                      {{ filter(list.visitDate) }}
                    </td>                  -->
                  <!-- <td class="text-center">
                      <i
                        class="fa fa-file-text edit-delete"
                        @click.prevent="
                          openFormsModal(
                            list.visitNo,
                            list.patientId,
                            list.studyId
                          )
                        "
                      ></i>
                    </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mx-0" v-if="overdueVisitList.length != 0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentoverduePage" :pages="totaloverduePages" active-color="#618bd7"
                    @update:modelValue="loadOverdue" />
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>

    </div>
  </div>

  <!-- Create Schedule Modal -->
  <teleport to="#app">
    <div v-if="showScheduleModal" class="schedule_modal__wrapper">
      <div class="schedule_modal__container">
        <div class="titleclass d-flex justify-content-between py-2 px-3">
          <h4 class="my-0">{{ $t("navigations.Create schedule") }}</h4>
          <div class="cursor-pointer">
            <i class="fa fa-times fs-5" title="Close" @click.prevent="closeScheduleModal()"></i>
          </div>
        </div>
        <div class="schedule_modal__content p-3">
          <div class="row">
            <!-- Left Column -->
            <div class="col-md-6">
              <!-- CRA ID -->
              <div class="form-group">
                <label for="craid">CRA
                  <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup></label>

                <select class="form-control" id="craid" v-model="scheduleForm.craid" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="user in userList" :key="user.email" :value="user.email">
                    {{ user.email }}
                  </option>
                </select>
                <span v-if="formErrors.cra" class="text-danger">{{ formErrors.cra }}</span>
              </div>

              <!-- Site Code -->
              <div class="form-group">
                <label for="siteCode">{{ $t("navigations.site code") }}</label>
                <input type="text" class="form-control" id="siteCode" v-model="scheduleForm.siteCode" readonly />
              </div>
              <div class="form-group">
                <label>Checklist</label>
                <Multiselect v-model="scheduleForm.checklist" mode="multiple" :searchable="true"
                  placeholder="Select Checklist items" :options="checklists" :hideSelected="false"
                  :closeOnSelect="false" class="multiselect-theme">
                </Multiselect>
              </div>

              <!-- Planned Date -->
              <div class="form-group">
                <label for="plannedDate">{{ $t("navigations.planned date") }}</label>
                <input type="date" class="form-control" id="plannedDate" v-model="scheduleForm.plannedDate" />
              </div>


              <!-- Triggered By -->
              <div class="form-group">
                <label for="triggeredBy">{{ $t("navigations.reason") }}</label>
                <select class="form-control" id="triggeredBy" v-model="scheduleForm.triggeredBy" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="trigger in triggeredByOptions" :key="trigger" :value="trigger">
                    {{ trigger }}
                  </option>
                </select>
              </div>

              <!-- Immediate Date -->
              <!-- <div class="form-group">
                <label for="immediateDate">{{ $t("navigations.immediate date") }}</label>
                <input type="date" class="form-control" id="immediateDate" v-model="scheduleForm.immediateDate" />
              </div> -->


            </div>

            <!-- Right Column -->
            <div class="col-md-6">
              <!-- CRA Visit Type -->
              <div class="form-group">
                <label for="craVisitType">{{ $t("navigations.visit type") }}</label>
                <select class="form-control" v-model="scheduleForm.craVisitTypeId" @change="onVisitTypeChange">
                  <option value="">Select</option>
                  <option v-for="type in visitTypes" :key="type.id" :value="type.id">
                    {{ type.type }}
                  </option>
                </select>


              </div>

              <!-- Visit Name -->
              <div class="form-group">
                <label for="visitName">{{ $t("navigations.visit name") }}</label>
                <input type="text" class="form-control" id="visitName" v-model="scheduleForm.visitName" />
              </div>

              <!-- Monitoring Mode -->
              <div class="form-group">
                <label for="monitoringMode">{{ $t("navigations.monitoring mode") }}</label>
                <select class="form-control" id="monitoringMode" v-model="scheduleForm.monitoringMode" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="mode in monitoringModeOptions" :key="mode" :value="mode">
                    {{ mode }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Status</label>
                <select v-model="scheduleForm.status" class="form-control">
                  <option value="">Select</option>
                  <option value="Planned">Planned</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Rescheduled">Rescheduled</option>
                  <option value="Overdue">Overdue</option>
                </select>
              </div>
              <!--  Comment box when Others is selected -->
              <div class="form-group mt-2" v-if="scheduleForm.triggeredBy === 'Others'">
                <label for="triggeredByComment">
                  Please specify the reason
                </label>
                <textarea id="triggeredByComment" class="form-control" rows="3"
                  v-model="scheduleForm.triggeredByComment" placeholder="Please specify the reason" required></textarea>
              </div>


              <!-- Override Planned Date -->
              <!-- <div class="form-check mt-5">
                <input type="checkbox" class="form-check-input" id="overridePlannedDate"
                  v-model="scheduleForm.overridePlannedDate" />
                <label class="form-check-label" for="overridePlannedDate">
                  {{ $t("navigations.override planned date") }}
                </label>
              </div> -->



            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end mt-3">
            <button type="button" class="cancel_btn py-1 px-4 mx-2" @click.prevent="closeScheduleModal()">
              {{ $t("navigations.cancel") }}
            </button>
            <button type="submit" class="save_btn py-1 px-4" @click.prevent="submitSchedule()">
              {{ $t("navigations.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Risks Modal -->
  <teleport to="#app">
    <div v-if="showRisksModal" class="risks_modal__wrapper">
      <div class="risks_modal__container">
        <div class="titleclass d-flex justify-content-between py-2 px-3">
          <h4 class="my-0">{{ $t("navigations.kpis") }} - {{ selectedSite?.siteCode }}</h4>
          <div class="d-flex gap-3 align-items-center">

            <div class="cursor-pointer">
              <i class="fa fa-times fs-5" title="Close" @click.prevent="closeRisksModal()"></i>
            </div>
          </div>
        </div>
        <div class="summary-heading px-3 py-0">
          <div class="row py-1 align-items-center">
            <div class="col-4 text-left d-flex ">
              <h4 class="stats-label pr-1">{{ $t("navigations.Aggregate Risk Score") }}: </h4>
              <h4>{{ selectedSite?.siteScore }}</h4>
            </div>
            <div class="col-4 text-left d-flex ">
              <h4 class="stats-label pr-1">{{ $t("navigations.status") }}: </h4>
              <h4>{{ selectedSite?.status }}</h4>
            </div>
            <div class="col-4 d-flex justify-content-end align-items-center">
              <div class="position-relative cursor-pointer" title="Create Schedule">
                <img class="cursor-pointer create-btn-icon mb-1" src="../../assets/img/create.png" alt="Create Schedule"
                  @click.prevent="createSchedule()">
                <div class="tool-tip">{{ $t("navigations.Create schedule") }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="risks_modal__content p-3"
          :class="{ 'min-height-400': selectedSite?.risks && selectedSite.risks.length > 0 }">
          <div v-if="!hasRisks" class="text-center empty-state">
            <div class="empty-icon">
              <i class="fa fa-info-circle"></i>
            </div>
            <p>{{ $t('navigations.no risks data') }}</p>
          </div>
          <table v-else class="table risks-table">
            <thead>
              <th >{{ $t("navigations.risk name") }}</th>
              <th class="text-center">{{ $t("navigations.derived value") }}</th>
              <th class="text-center">{{ $t("navigations.Weighted Risk Score") }}</th>
              <th class="text-center">{{ $t("navigations.probability") }}</th>
              <th class="text-center">{{ $t("navigations.impact") }}</th>
              <th class="text-center">{{ $t("navigations.detectability") }}</th>
            </thead>
            <tr v-for="(risk, index) in selectedSite.risks" :key="index">
              <td class="py-0">
                <div class="py-0">
                  <strong>{{ risk.riskName }}</strong>
                  <br />
                  <small class="text-muted">
                    {{ risk.unit }}
                  </small>
                </div>
              </td>
              <td class="py-2 text-center">{{ risk.value }}</td>
              <td class="py-2 text-center">
                <span :style="{ backgroundColor: risk.riskLevelColor || '#999' }" class="badge p-1"
                  data-toggle="tooltip" data-placement="top"
                  title="Risk score after applying KPI criticality weight to the base P×I×D score.">
                  {{ risk.score }}
                </span>
              </td>
              <td class="py-2 text-center">{{ risk.probability }}</td>
              <td class="py-2 text-center">{{ risk.impact }}</td>
              <td class="py-2 text-center">{{ risk.detectability }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </teleport>

</template>
<script src="./KPIs.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/font-awesome/css/font-awesome.css";

.max-scroll-300 {
  max-height: 300px;
  overflow-y: scroll;
}

.custom-tooltip-wrapper {
  position: relative
}

.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;

}

.custom-tooltip-text:popover-open {
  display: grid;
}

.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.widgetmargin {
  margin-top: -13px !important;
}

.ibox-body {
  background-color: #ffffff;
  margin: 3rem, 0;
}

.style1 {
  background-color: #3c4192 !important;
  color: #ffffff;
}

.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}

.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}

.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}

.ibox-title {
  color: inherit;
  margin-bottom: 0;
  padding: 1rem;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  width: unset !important;
  margin-left: 0px !important;
  margin-top: 0px !important;
}

.padding_bottom {
  padding-bottom: 2rem;
}

.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}

.titlemsg {
  padding: 20px 20px;
  font-size: 15px;
  font-weight: bold;
  color: #145faf;
}

.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}

.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}

.graphbutton {
  width: fit-content;
  padding: 3px;
  cursor: pointer;
}

.graphbtncontainer {
  display: flex;
  gap: 5px;
}

img {
  margin-left: 0px !important;
}

.minwidthdiv {
  height: 420px;
  overflow: hidden;
}

.ibox-title h5 {
  float: none;
}

.tableheight {
  height: 100%;
  padding: 7px;
}

.strechtable {
  height: 100%;
}

.mt-1,
.my-1 {
  margin-left: 0 !important;
}

.patientcountchartdiv {
  overflow: auto;
}

.btn-setdefault {
  position: relative;
  padding: 0.2rem 0.4rem;
  text-align: center;
  font-size: 0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius: 3px;
}

.ibox-content h1 {
  font-weight: 400;
  color: #676a6c;
}

.cursor-pointer {
  cursor: pointer;
}

.edit-delete {
  color: #3c4192;
}

.edit-delete:hover {
  color: #bb458f;
  transition: color 0.3s ease;
}

.empty-state {
  padding: 2rem 1rem;
  background-color: #f9f9f9;
  border-radius: 4px;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  color: #ccc;
  margin-bottom: 1rem;
}

.empty-state h5 {
  color: #666;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.empty-state p {
  color: #999;
  margin: 0;
}

/* Risks Modal Styles */
.risks_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
}

.risks_modal__container {
  width: min(70%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
}

.titleclass {
  color: #ffffff;
  background: #768dd3;
  z-index: 2000;
}

.titleclass h4 {
  font-weight: 600;
  font-size: 1.1rem;
}

.titleclass i {
  font-size: 1.3rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.titleclass i:hover {
  color: #f0f0f0;
}

.summary-heading {
  background-color: #f9f9f9;
  border-bottom: 1px solid #e7eaec;
}

.stats-label {
  display: block;
  color: #999;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.summary-heading h4 {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 1rem;
}

.risks_modal__content {
  max-height: 600px;
  overflow-y: auto;
}

.max-height-500 {
  overflow-y: scroll;
  height: 500px;
}

.risks-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}

.risks-table thead {
  background-color: #ffffff;
  border-top: 1px solid #e7eaec;
  position: sticky;
  top: 0;
  z-index: 100;
}

.risks-table thead th {
  padding: 4px 8px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e7eaec;
  font-size: 0.9rem;
}

.risks-table tbody tr {
  border-bottom: 1px solid #e7eaec;
}

.risks-table tbody tr:hover {
  background-color: #f9f9f9;
}

.risks-table tbody td {
  padding: 1rem;
  color: #555;
  font-size: 0.9rem;
  vertical-align: middle;
}

.risk-badge {
  padding: 0.35rem 0.75rem;
  border-radius: 4px;
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
}

.create-btn-icon {
  width: 20px;
  height: 20px;
  transition: opacity 0.2s ease;
}

.create-btn-icon:hover {
  opacity: 0.8;
}

.gap-3 {
  gap: 1rem;
}

.tool-tip {
  position: absolute;
  bottom: 100%;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  pointer-events: none;
  z-index: 1001;
  margin-bottom: 5px;
}

.position-relative:hover .tool-tip {
  opacity: 1;
  visibility: visible;
}

/* Create Schedule Modal Styles */
.schedule_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 4000;
}

.schedule_modal__container {
  width: min(50%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.schedule_modal__content {
  max-height: 600px;
  overflow-y: auto;
}

.schedule_modal__content .form-group {
  margin-bottom: 1.5rem;
}

.schedule_modal__content label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.schedule_modal__content .form-control {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.schedule_modal__content .form-control:focus {
  border-color: #768dd3;
  box-shadow: 0 0 0 0.2rem rgba(118, 141, 211, 0.25);
  outline: none;
}

.schedule_modal__content .form-control[readonly] {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #768dd3;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #5a71a8;
}

.btn-secondary {
  background-color: #e0e0e0;
  color: #333;
  border: none;
}

.btn-secondary:hover {
  background-color: #d0d0d0;
}

.gap-2 {
  gap: 0.5rem;
}

.save_btn {
  background-color: #6a97e7 !important;
  /* border-color: #1ab394; */
  border: none;
}

.text-danger {
  color: red;
}

.table th,
.table td {
  vertical-align: center !important;
  border-top: 1px solid #dee2e6;
}
</style>
